import { Address, L2AccountId, L2ChainId, Timestamp, TokenId } from 'types'
import { ApiV1Response, http } from './http'

export enum HistoryType {
  Deposit = 'DEPOSIT',
  Withdraw = 'WITHDRAW',
  Transfer = 'TRANSFER',
}
export const TransactionsStatusMaps = {
  SUCCESS: 'Successful',
  FAILED: 'Failed',
  PENDING: 'Processing',
}
export const TransactionsDays = [
  {
    label: 'Past 7 days',
    key: '7',
  },
  {
    label: 'Past 30 days',
    key: '30',
  },
  {
    label: 'Past 90 days',
    key: '90',
  },
]

export interface TransactionsFilterParams {
  limit?: number
  offsetId: number
  days?: string
  currency?: string
  status?: keyof typeof TransactionsStatusMaps
  txHash?: string
}
export interface HistoryParams extends TransactionsFilterParams {
  type: HistoryType
  accountId: number
}
export enum HistoryStatusType {
  padding = 'PENDING',
  fail = 'FAILED',
  success = 'SUCCESS',
}
export interface ApiHistoryItem {
  txId: number
  ethHash?: string // Only for deposit
  userId: number
  accountId: number
  l2AccountId: L2AccountId
  txHash: string
  txType: HistoryType
  txStatus: HistoryStatusType
  chainId: L2ChainId
  fromAddress: Address
  toAddress: Address
  currencyId: TokenId
  fee: number
  amount: number
  extra: string // E.g. "{\"withdrawFeeRatio\":0,\"withdrawToL1\":0}"
  newPkHash: string
  nonce: number
  ts: Timestamp
  pubKey: string
  signature: string
  ethAuthData: string
  ethSignature: string
  createdAt: Timestamp
  updatedAt: Timestamp
}
export function getTransactions(params: HistoryParams): Promise<
  ApiV1Response<{
    results: ApiHistoryItem[]
    hasMore: boolean
    nextOffsetId: number
    range: string
  }>
> {
  const { accountId, limit = 10, ...ps } = params
  return http
    .get(`/account/${accountId}/transactions`, {
      params: {
        ...ps,
        limit,
      },
    })
    .then((r) => r.data)
}
